import React from 'react';

class SandboxedHTMLContent extends React.Component {

  render = () => {
    let html_part = this.props.htmlPart
    html_part = html_part.replace(/cid:\S+"/g, (m) => {
      const docToReplace = this.props.documents.find( doc => doc.cid === m.slice(4, -1))
      if(docToReplace) return docToReplace.documentUrl + '"'
    })

    html_part = encodeURIComponent(html_part);

    return (
      <iframe 
        style={this.props.contentStyle}
        title="sandboxedHTMLContent"
        src={`data:text/html;charset=utf-8,${html_part}`}
        sandbox=""></iframe>
    )
  }
}

export default SandboxedHTMLContent;



// WEBPACK FOOTER //
// ./src/component/SandboxedHTMLContent.js